import { render, staticRenderFns } from "./DashboardMotorista.vue?vue&type=template&id=201c1355&"
import script from "./DashboardMotorista.vue?vue&type=script&lang=js&"
export * from "./DashboardMotorista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports